import type { Extension, Resource } from "@medplum/fhirtypes";
import { isStandardParameter, STANDARD_PARAMETER_KEYS, type StandardParameterReference } from "@repo/domain";
import { oneOf } from "./read";

const STANDARD = "standard";

export function parameterExtensions<A extends object>(
  url: string,
  entries: readonly (A | StandardParameterReference)[],
  authored: (entry: A) => Extension,
): Extension[] {
  return entries.map((entry) =>
    isStandardParameter(entry) ? { url, extension: [{ url: STANDARD, valueCode: entry.key }] } : authored(entry),
  );
}

export function isStandardParameterExtension(member: Extension): boolean {
  return member.extension?.some((field) => field.url === STANDARD) ?? false;
}

function standardCode(member: Extension): string | undefined {
  const field = member.extension?.find((child) => child.url === STANDARD);
  return field?.valueCode ?? field?.valueString;
}

/** Unknown platform entries are omitted like other unreadable catalog members. */
export function readStandardParameterReference(member: Extension): StandardParameterReference | undefined {
  const raw = standardCode(member);
  const key = STANDARD_PARAMETER_KEYS.find((candidate) => candidate === raw);
  return key ? { kind: "standard", key } : undefined;
}

export function requireStandardParameterReference(row: Resource, member: Extension): StandardParameterReference {
  return { kind: "standard", key: oneOf(row, "parameter.standard", standardCode(member), STANDARD_PARAMETER_KEYS) };
}
